export default {
  en: {
    common: {
      bookNow: 'Book now',
      bookAppointment: 'Book an appointment',
      findOutMore: 'Find out more',
      newsLetter: 'Get the newsletter',
      visitQigong: 'Visit the Qigong Site',
      next: 'Next',
      emailAddress: 'Email Address',
      firstName: 'First name',
      lastName: 'Last name',
      legal: 'All rights reserved.',
      learnMore: 'Learn more'
    },
    nav: {
      formations: 'Formations'
    },
    address: {
      laurierMetro: 'Laurier Station'
    },
    header: {
      title:
        'The mission of Centre Qigong Laflamme is to help people become proactive in their journey towards better health.'
    },
    qigong: {
      title: 'Qigong Workshops',
      subtitle:
        'Our qigong workshops are open to all levels. Each session combines movement and meditation, guided by principles of traditional Chinese medicine.',
      explore: 'Explore Workshops',
      workshops: [
        {
          title: 'Les 5 saisons de la médecine chinoise: Terre – Eau',
          date: '18 octobre 2026',
          location: 'Studios Lyne St-Roch (Magog)',
          link:
            'https://www.lynestroch.com/activite/le-retrait-des-sensretraite-de-yoga-meditation-2/les-5-saisons-de-la-medecine-chinoiseterre-eau/'
        },
        {
          title: 'La bulle énergétique',
          date: '6 décembre 2026',
          location: 'Studios Lyne St-Roch (Magog)',
          link: 'https://www.lynestroch.com/activite/la-bulle-energetiqueqigong/'
        },
        {
          title: 'Les 5 saisons de la médecine chinoise: Terre – Bois',
          date: '17 janvier 2027',
          location: 'Studios Lyne St-Roch (Magog)',
          link: 'https://www.lynestroch.com/activite/les-5-saisons-de-la-medecine-chinoiseterre-bois/'
        },
        {
          title: 'La bulle énergétique',
          date: '21 février 2027',
          location: 'Studios Lyne St-Roch (Magog)',
          link: 'https://www.lynestroch.com/activite/la-bulle-energetiqueqigong-2/'
        }
      ]
    },
    acupuncture: {
      title: "The focus of my practice is to strengthen one's natural ability to heal and regenerate. ",
      content:
        'Sean began his studies in Chinese Medicine in 1994 and, since then, has had the privilege of guiding many people on their journeys of transformation and healing. As an acupuncturist, he helps patients become aware of the ways in which they can actively participate in improving their own energy and well-being.'
    }
  },
  fr: {
    common: {
      bookNow: 'Rendez-Vous',
      bookAppointment: 'Prendre rendez-vous',
      findOutMore: 'En savoir plus',
      newsLetter: "S'inscrire à l'infolettre",
      visitQigong: 'Visitez le Site Qigong',
      next: 'Suivant',
      emailAddress: 'Adresse courriel',
      firstName: 'Prénom',
      lastName: 'Nom',
      legal: 'Tous droits réservés.',
      learnMore: 'En savoir plus'
    },
    nav: {
      formations: 'Formations'
    },
    address: {
      laurierMetro: 'Station Laurier'
    },
    header: {
      title: `Le  Centre de Qigong Laflamme aide les gens à devenir proactifs dans leur cheminement vers une meilleure santé.`
    },
    qigong: {
      title: 'Ateliers de qigong',
      subtitle:
        'Nos ateliers de qigong s’adressent à tous les niveaux. Chaque séance combine mouvements et méditation, guidée par des principes de la médecine traditionnelle chinoise.',
      explore: 'Explorer les ateliers',
      workshops: [
        {
          title: 'Les 5 saisons de la médecine chinoise: Terre – Eau',
          date: '18 octobre 2026',
          location: 'Studios Lyne St-Roch (Magog)',
          link:
            'https://www.lynestroch.com/activite/le-retrait-des-sensretraite-de-yoga-meditation-2/les-5-saisons-de-la-medecine-chinoiseterre-eau/'
        },
        {
          title: 'La bulle énergétique',
          date: '6 décembre 2026',
          location: 'Studios Lyne St-Roch (Magog)',
          link: 'https://www.lynestroch.com/activite/la-bulle-energetiqueqigong/'
        },
        {
          title: 'Les 5 saisons de la médecine chinoise: Terre – Bois',
          date: '17 janvier 2027',
          location: 'Studios Lyne St-Roch (Magog)',
          link: 'https://www.lynestroch.com/activite/les-5-saisons-de-la-medecine-chinoiseterre-bois/'
        },
        {
          title: 'La bulle énergétique',
          date: '21 février 2027',
          location: 'Studios Lyne St-Roch (Magog)',
          link: 'https://www.lynestroch.com/activite/la-bulle-energetiqueqigong-2/'
        }
      ]
    },
    acupuncture: {
      title: 'Un point central de ma pratique est de renforcer sa capacité naturelle à guérir et à se régénérer.',
      content:
        'Sean a débuté ses études en médecine chinoise en 1994 et, depuis, il a le privilège d’accompagner de nombreuses personnes sur leur chemin de transformation et de guérison. En tant qu’acupuncteur, il aide ses patients à prendre conscience de la façon dont ils peuvent eux-mêmes contribuer à l’amélioration de leur énergie.'
    }
  }
}
